import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

interface MediaKitAnalyticsLayoutProps {
    title?: string;
    children: ReactNode;
    platformUrl?: string | null;
    platformIcon?: ReactNode;
}

export const MediaKitAnalyticsLayout: React.FC<MediaKitAnalyticsLayoutProps> = ({
    children,
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {children}
        </Box>
    );
};
